/*!

*/
import React, {useEffect, useState} from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch, useLocation, useHistory} from "react-router-dom";
import axios from 'axios';
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import API from "../carrental/src/contained/API"
import routes from "routes.js";
import jwtDecode from "jwt-decode";
import { useDispatch} from 'react-redux'
import { areaFetch, featureFetch} from "../actions/actions"
import { connect } from 'react-redux'
import swal from "sweetalert";
import dlogo from "./logo.png"
import Spin from '../assets/img/Spinner2.gif'

var ps;

function Admin(props) {
  let history = useHistory();
  let dispatch = useDispatch()
  const [authenticated, setAuthenticated] = useState(false)
  const [showProcessing , setShowProcessing] = useState(false)
  const location = useLocation();
  const [backgroundColor, setBackgroundColor] = React.useState("black");
  const [activeColor, setActiveColor] = React.useState("info");
  const [sidebarMini, setSidebarMini] = React.useState(true);
  const mainPanel = React.useRef();
  const [alert, setAlert] = React.useState(null);
 
    {/**  , backgroundImage : `url(${imgg})`,backgroundRepeat: 'no-repeat', backgroundSize: 'cover' */}
  
  useEffect(() => {
   // authentic()
    dispatch(areaFetch())
    dispatch(featureFetch())
 
    
  }, [])

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(mainPanel.current);
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
        document.documentElement.className += " perfect-scrollbar-off";
        document.documentElement.classList.remove("perfect-scrollbar-on");
      }
    };
  });
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainPanel.current.scrollTop = 0;
  }, [location]);
  
  
  const SpinnerNew = <div className="spoverlay"><center><img style={{marginTop : 200}} src={Spin} alt="a" width={"200px"}/><h4>Please wait...</h4></center></div>

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={() => <prop.component swal={swal} Spin={SpinnerNew} API={API} history={history}/>}
            key={key}
            
          />
        );
      } else {
        return null;
      }
    });
  };
  const handleActiveClick = (color) => {
    setActiveColor(color);
  };
  const handleBgClick = (color) => {
    setBackgroundColor(color);
  };
  const handleMiniClick = () => {
    if (document.body.classList.contains("sidebar-mini")) {
      setSidebarMini(false);
    } else {
      setSidebarMini(true);
    }
    document.body.classList.toggle("sidebar-mini");
  };



  return (
    <div className="wrapper">
     {alert}
      <Sidebar
        {...props}
        routes={routes}
        bgColor={backgroundColor}
        activeColor={activeColor}
      />
      <div className="main-panel" ref={mainPanel}>
        <AdminNavbar {...props} handleMiniClick={handleMiniClick} />
       
     
          {!showProcessing ? <> 
                  <Switch>{getRoutes(routes)}</Switch>
                  {
                    // we don't want the Footer to be rendered on full screen maps page
                    props.location.pathname.indexOf("full-screen-map") !== -1 ? null : (
                      <Footer fluid />
                    )
                  }
                     
                        </> : 
                  <>
                  <center>
                    <img className="mute-anim py-4 text-center" src = {dlogo} alt={"..."} width="200px" style={{marginTop : "200px"}}/>
                  </center>
                  <center>Please wait ...</center>
                  </> 
          } 
       
     
       
       
      </div>
     
    </div>
    
  );
}

export default connect(null, {areaFetch} )(Admin);
